import { addHours } from 'date-fns';
import { SchedulerGridCell } from '../cell';
import { SchedulerGridHeaderHour } from './hour';
import { useElementMeasures } from '@hooks/useElementMeasures';
import { useAppScrollTop } from '@hooks/appScroll';
import { useSchedulerContext } from '@contexts/scheduler';
import { getHours } from '../helpers';
import { cn } from '@utils/cn';
import { FullDaySwitch } from '@components/fullDaySwitch';

export const SchedulerGridHeader = () => {
  const {
    date,
    modal,
    hours: dividedHours,
    hoursCount,
    showFullDay,
    outOfScopeRecords,
    setState,
  } = useSchedulerContext();
  const hours = dividedHours.length
    ? dividedHours.map((segments) => segments[0])
    : getHours(date, hoursCount);

  const navigation = useElementMeasures('scheduler-navigation').height;
  const tabHeader = useElementMeasures('page-header');
  const scrollTop = useAppScrollTop();
  const headerHeight = modal ? 0 : tabHeader.y + tabHeader.height + navigation - scrollTop;

  return (
    <>
      <SchedulerGridCell
        className={cn(['z-30 items-center border-l-0 bg-white p-0 px-2 sticky border-b-2'])}
        style={{ top: headerHeight }}>
        <FullDaySwitch
          checked={showFullDay}
          onCheckedChange={(checked) =>
            setState((prev) => ({ ...prev, showFullDay: checked, showFullDayOverridden: true }))
          }
          hasOutOfScopeRecords={outOfScopeRecords}
        />
      </SchedulerGridCell>
      {hours.map((hour, i) => (
        <SchedulerGridCell
          key={`scheduler-grid-header-${hour.getTime()}`}
          className={cn(['z-30 border-b-2 border-l-0 bg-white p-0 sticky'])}
          style={{ top: headerHeight }}>
          <SchedulerGridHeaderHour className="relative left-0 -translate-x-1/2" data={hour} />
          {i === hours.length - 1 && (
            <SchedulerGridHeaderHour
              className="absolute right-0 translate-x-1/2"
              data={addHours(hour, 1)}
            />
          )}
        </SchedulerGridCell>
      ))}
    </>
  );
};
